import React from "react";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogClose,
} from "../ui/dialog";
import { Input } from "../ui/input";
import { Button } from "../ui/button";

interface GenericEditModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  values: {
    generic_name_name: string;
  };
  genericNameId: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSave: (genericNameId: string, genericName: string) => void;
  onCancel: () => void;
  trigger: React.ReactNode;
}

const GenericEditModal: React.FC<GenericEditModalProps> = ({
  open,
  onOpenChange,
  values,
  genericNameId,
  onChange,
  onSave,
  onCancel,
  trigger,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogTrigger asChild>{trigger}</DialogTrigger>
    <DialogContent className="text-black">
      <DialogHeader>
        <DialogTitle>Edit Generic</DialogTitle>
      </DialogHeader>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1 text-black">
            Name
          </label>
          <Input
            name="generic_name_name"
            value={values.generic_name_name}
            onChange={onChange}
          />
        </div>
        {/* Last Used and Usage Count fields removed as requested */}
      </div>
      <DialogFooter className="mt-4">
        <Button
          size="sm"
          onClick={() => onSave(genericNameId, values.generic_name_name)}
          variant="default"
        >
          Save
        </Button>
        <DialogClose asChild>
          <Button size="sm" onClick={onCancel} variant="outline">
            Cancel
          </Button>
        </DialogClose>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default GenericEditModal;
